var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{attrs:{"input-value":_vm.darkTheme,"label":_vm.$t('config.dark-theme'),"inset":"","dense":""},on:{"change":_vm.onSelectTheme}})
}
var staticRenderFns = []

export { render, staticRenderFns }